export enum ExperienceCardType {
  Regular = 'regular',
  Auction = 'auction',
  Permanent = 'permanent',
  Contest = 'contest',
}

export enum Role {
  Exminder = 'exminder',
  Explorer = 'explorer',
}

export enum ExperienceStatus {
  Draft = 'draft',
  Active = 'active',
  Upcoming = 'upcoming',
  Progress = 'in_progress',
  Completed = 'completed',
  Expired = 'expired',
  Canceled = 'canceled',
  ShadowBanned = 'shadow_banned',
}
export enum RequestStatus {
  Pending = 'pending',
  Approved = 'accepted',
  Rejected = 'rejected',
  AutomaticallyRejected = 'automatically_rejected',
}
export enum ExplorerExperienceStatus {
  Upcoming = 'upcoming',
  Auction = 'auction',
  Past = 'completed',
  Requested = 'requested',
}

export enum PermanentExperienceSteps {
  IM_INTERESTED = 0,
  GET_APPROVED_AND_BUY = 1,
  GET_IN_CONTACT = 2,
  MEET_IN_PERSON_AND_REQUEST_PIN = 3,
  START_EXPERIENCE = 4,
}

export enum OneTimeExperienceSteps {
  BUY_EXPERIENCE = 0,
  GET_IN_CONTACT = 1,
  MEET_IN_PERSON_AND_REQUEST_PIN = 2,
  START_EXPERIENCE = 3,
}
